import axios from '@/axios'

export default {
  createstripesession(evententry) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/stripe-payment/create-session/${evententry._id}`, {})
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.data)
        })
    })
  },
  addstripesource(source, clientsecret, evententry) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/stripe-sources/add`, {
          source: source,
          evententry: evententry,
          clientsecret: clientsecret
        })
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.data)
        })
    })
  },
  getstripedetails(evententry) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/stripe-details/${evententry.event._id}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.data)
        })
    })
  }
}
